/**
 * <TutorApplicationChampionAsksSkeleton> — la place du champion qui pose la question, le temps qu'elle
 * se charge : sa silhouette (la toile de `<ChampionFigure>` à sa hauteur) et deux lignes dans la bulle.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { FIGURE_RATIO } from "../../atoms/ChampionFigure/championDance"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { SPEECH_BUBBLE_LIFT } from "../SpeechBubble"
import { TUTOR_APPLICATION_ASKER_HEIGHT } from "./TutorApplicationChampionAsks"

export function TutorApplicationChampionAsksSkeleton() {
    return (
        <Row gap="2" align="end">
            <Skeleton
                shape="block"
                width={Math.round(TUTOR_APPLICATION_ASKER_HEIGHT * FIGURE_RATIO)}
                height={TUTOR_APPLICATION_ASKER_HEIGHT}
                radius="lg"
            />
            <View style={styles.bubble}>
                <Stack gap="1">
                    <Skeleton textSize="text-lg" width="90%" />
                    <Skeleton textSize="text-lg" width="60%" />
                </Stack>
            </View>
        </Row>
    )
}

const styles = StyleSheet.create((theme) => ({
    bubble: { flex: 1, minWidth: 0, paddingBottom: theme.spacing[SPEECH_BUBBLE_LIFT] },
}))
